import * as React from 'react';
import { useTabs } from './Tabs';
import { PanelDescription } from './style';

export interface IPanelProps {
  /**
   * Unique identifier for this tab.
   */
  label: string;
  children?: React.ReactNode;
  id: number;
  /**
   * Optional description to display above the panel content.
   */
  description?: string;
}

export const Panel: React.FC<IPanelProps> = (props: IPanelProps) => {
  /**
   * Individual panel component.
   */
  const { activeTab } = useTabs();
  return activeTab === props.id ? (
    <div>
      {props.description && <PanelDescription>{props.description}</PanelDescription>}
      {props.children}
    </div>
  ) : null;
};
